import { transliterationMap } from './transliteration-map.constant';

export const sanitizeIdentifier = (value: string): string => {
  let result = value.toLowerCase();

  // Apply transliteration
  result = result.replace(/[^\x00-\x7F]/g, (char) => transliterationMap[char] || '');

  // Apostrophes inside words - remove
  result = result.replace(/([a-z])'([a-z])/g, '$1$2');

  // Replace spaces, underscores, apostrophes, pluses with hyphen
  result = result.replace(/[\s_'+]+/g, '-');

  // Remove all non-allowed characters (includes Cyrillic, Arabic, Chinese, Greek)
  result = result.replace(/[^a-z0-9-]/g, '');

  // Collapse multiple hyphens
  result = result.replace(/-+/g, '-');

  // Trim hyphens
  result = result.replace(/^-+|-+$/g, '');

  return result;
};
